export default "__VITE_ASSET__CTXrxyYy__"